
export class  WarrantyServiceListingResponseModel{
    title : string; 
    id : number; 
} 
    
export class WarrantyServiceListing {
    WarrantyServiceList:  Array<WarrantyServiceListingResponseModel> = []; 
 }

 
export class  ProductWarrantyServiceModel{
    title : string; 
    id : number;
    isActive:boolean;
    isSelected:boolean; 
} 